<template>
	<div v-loading="dataLoading">
		<template v-if="data">
			<div class="page-group-title"><span>短信营销演出ID:{{data.activityId}}</span></div>
			<el-card shadow="never" class="statistics-box" header="短信触达">
				<el-row :gutter="20">
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.sendNum }}</p>
						<p class="color-info">短信发送条数</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.successNum}}</p>
						<p class="color-info">成功触达条数</p>
					</el-col>					
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.successRate}} %</p>
						<p class="color-info">成功发送率</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.linkClickNum }}</p>
						<p class="color-info">短链点击次数</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.linkClickUserNum }}</p>
						<p class="color-info">短链点击人数</p>
					</el-col>					
				</el-row>
			</el-card>
			<el-card class="box-card MT20" v-if="data && data.activeUser7VO || data.activeUser30VO" header="触达用户活跃度对比">
				<el-tabs v-model="activeName" @tab-click="handleClick" class="MB20">
					<el-tab-pane label="7天" name="7days">7天</el-tab-pane>
					<el-tab-pane label="30天" name="30days">30天</el-tab-pane>
				</el-tabs>
				<div id="VitalityChart" v-if="data.activeUser7VO && data.activeUser30VO"></div>
			</el-card>
			<el-card v-if="data && data.accessData || data.accessData" header="触达用户演出访问" shadow="never"
				class="statistics-box MT20">
				<el-row :gutter="20">
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.accessData.totalNum }}</p>
						<p class="color-info">演出详情访问总次数</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.accessData.userNum}}</p>
						<p class="color-info">演出详情访问总人数</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.accessData.totalNum7}}</p>
						<p class="color-info">演出详情近7日访问次数</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.accessData.userNum7}}</p>
						<p class="color-info">演出详情近7日访问人数</p>
					</el-col>
				</el-row>
				<div id="VisitChart" v-if="data.accessData.accessDataList && data.accessData.accessDataList.length > 0" class="MT20"></div>
			</el-card>
			<el-card v-if="data && data.orderData || data.orderData" header="触达用户演出下单" shadow="never"
				class="statistics-box MT20">
				<el-row :gutter="20">
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.orderData.orderNum }}</p>
						<p class="color-info">订单数量</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.orderData.userNum}}</p>
						<p class="color-info">下单人数</p>
					</el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4">
						<p class="num">{{data.orderData.totalAmount}}</p>
						<p class="color-info">订单金额</p>
					</el-col>
				</el-row>
				<div id="OrderChart" v-if="data.orderData.orderDataList && data.orderData.orderDataList.length > 0" class="MT20"></div>
			</el-card>
		</template>
	</div>
</template>

<script>
	import {
		Chart
	} from '@antv/g2';
	

	export default {
		components: {},
		data() {
			return {
				id: this.$route.params.id,
				dataLoading: false,
				data: null,
				activeName: '7days',
				chart1: null,
				chart2: null,
				chart3: null,
				dayName: '7days'
			}
		},
		created() {
			this.getData();
		},
		watch: {

		},
		methods: {

			//获取数据
			getData() {
				this.dataLoading = true;
				this.$request({
						url: "/smsMarketing/data",
						method: "get",
						params: {
							id: this.id
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.dataLoading = false;
							this.data = result;
							// this.data.activeUser7VO.beforeNum = 20
							// this.data.activeUser7VO.afterNum = 90
							// this.data.activeUser30VO.beforeNum = 100
							// this.data.activeUser30VO.afterNum = 50
							
							// this.data.accessData.accessDataList = [{
							// 		"strKey": "2025-03-01",
							// 		"longKey": 6,
							// 		"count": 6
							// 	},
							// 	{
							// 		"strKey": "2025-03-02",
							// 		"longKey": 4,
							// 		"count": 4
							// 	},
							// 	{
							// 		"strKey": "2025-03-03",
							// 		"longKey": 3,
							// 		"count": 2
							// 	},
							// 	{
							// 		"strKey": "2025-03-04",
							// 		"longKey": 6,
							// 		"count": 2
							// 	},
							// 	{
							// 		"strKey": "2025-03-05",
							// 		"longKey": 3,
							// 		"count": 6
							// 	},
							// 	{
							// 		"strKey": "2025-03-06",
							// 		"longKey": 1,
							// 		"count": 3
							// 	},
							// 	{
							// 		"strKey": "2025-03-07",
							// 		"longKey": 1,
							// 		"count": 10
							// 	},
							// 	{
							// 		"strKey": "2025-03-08",
							// 		"longKey": 1,
							// 		"count": 2
							// 	}
							// ]
							
							// this.data.orderData.orderDataList = [{
							// 		"strKey": "2025-03-01",
							// 		"longKey": 6,
							// 		"intKey": 6
							// 	},
							// 	{
							// 		"strKey": "2025-03-02",
							// 		"longKey": 4,
							// 		"intKey": 4
							// 	},
							// 	{
							// 		"strKey": "2025-03-03",
							// 		"longKey": 3,
							// 		"intKey": 2
							// 	},
							// 	{
							// 		"strKey": "2025-03-04",
							// 		"longKey": 6,
							// 		"intKey": 2
							// 	},
							// 	{
							// 		"strKey": "2025-03-05",
							// 		"longKey": 3,
							// 		"intKey": 6
							// 	},
							// 	{
							// 		"strKey": "2025-03-06",
							// 		"longKey": 1,
							// 		"intKey": 3
							// 	},
							// 	{
							// 		"strKey": "2025-03-07",
							// 		"longKey": 1,
							// 		"intKey": 10
							// 	},
							// 	{
							// 		"strKey": "2025-03-08",
							// 		"longKey": 1,
							// 		"intKey": 2
							// 	}
							// ]
							
							// this.data.orderData.orderDataList = [{
							// 		"strKey": "2025-03-01",
							// 		"longKey": 200,
							// 		"count": 2000
							// 	},
							// 	{
							// 		"strKey": "2025-03-02",
							// 		"longKey": 1234,
							// 		"count": 78
							// 	},
							// 	{
							// 		"strKey": "2025-03-03",
							// 		"longKey": 345,
							// 		"count": 452
							// 	},
							// 	{
							// 		"strKey": "2025-03-04",
							// 		"longKey": 56,
							// 		"count": 349
							// 	},
							// 	{
							// 		"strKey": "2025-03-05",
							// 		"longKey": 427,
							// 		"count": 12
							// 	},
							// 	{
							// 		"strKey": "2025-03-06",
							// 		"longKey": 341,
							// 		"count": 45
							// 	},
							// 	{
							// 		"strKey": "2025-03-07",
							// 		"longKey": 292,
							// 		"count": 234
							// 	},
							// 	{
							// 		"strKey": "2025-03-08",
							// 		"longKey": 258,
							// 		"count": 231
							// 	}
							// ]
							
							if (this.data.activeUser7VO && this.data.activeUser30VO) {
								
								this.$nextTick(() => {
									this.drawChart();
								})
							}
							if (this.data.accessData && this.data.accessData.accessDataList && this.data.accessData.accessDataList.length > 0) {
								this.$nextTick(() => {
									this.drawChart2()
								})
							}
							if (this.data.orderData && this.data.orderData.orderDataList && this.data.orderData.orderDataList.length > 0) {
								this.$nextTick(() => {
									this.drawChart3()
								})
							}

						} else {
							this.$message.error(msg || "请求失败");
						}
					})


			},
			handleClick(tab) {
				this.dayName = tab.name
				this.$nextTick(() => {
					this.drawChart();
				})
			},
			//触达用户活跃度对比   VitalityChart
			drawChart() {

				if (this.chart1) this.chart1.destroy();

				var _chartData = []
				if (this.dayName == '7days') {
					_chartData.push({
						name: '短信触达前7天',
						num: this.data.activeUser7VO.beforeNum,
					}, {
						name: '短信触达后7天',
						num: this.data.activeUser7VO.afterNum,
					})
				} else {
					_chartData.push({
						name: '短信触达前30天',
						num: this.data.activeUser30VO.beforeNum,
					}, {
						name: '短信触达后30天',
						num: this.data.activeUser30VO.afterNum,
					})
				}


				this.chart1 = new Chart({
					container: 'VitalityChart',
					autoFit: true,
					height: 120,
				});
				this.chart1.data(_chartData);
				this.chart1.interaction('active-region');

				this.chart1.tooltip({
					showTitle: false,
					showMarkers: false,
				});
				this.chart1
					.interval()
					.position('name*num')
					.size(30)
					.tooltip('name*num', (name, num) => {
						num = parseFloat(num);
						return {
							name: name,
							value: num,
						};
					});
				this.chart1.render();
			},
			drawChart2() {
				if (this.chart2) this.chart2.destroy();
				this.chart2 = new Chart({
					container: 'VisitChart',
					autoFit: true,
					height: 300,					  
				});
				this.chart2.data(this.data.accessData.accessDataList);
				this.chart2.scale({
				  strKey: {
				    alias: '日期',
				    type: 'time',
				  },
				  longKey: {
				    alias: '访问人数',
				    min: 0,
				    sync: true, 
				    nice: true,
				  },				 
				  count: {
				    alias: '访问次数',
					min: 0,
					sync: true, 
					nice: true,
				  },
				});
				this.chart2.axis('count', {
				  grid: null,
				  title: {},
				});
				this.chart2.axis('longKey', {
				  title: {},
				});
				
				this.chart2.tooltip({
				  showCrosshairs: true,
				  shared: true,
				});
				this.chart2.legend({
				  custom: true,
				    items: [
				      {
				        name: '访问次数', // 图例项名称，对应数据中的颜色字段值				       
				        marker: {symbol: 'square', style: {fill: '#4FAAEB', r: 4}} // 自定义标记样式
				      },
				      {
				        name: '访问人数',				       
				        marker: {symbol: 'circle', style: {fill: '#9AD681', r: 4}}
				      }
				    ]
				});
				this.chart2
				  .line()
				  .position('strKey*count')
				  .color('#4FAAEB');
				this.chart2
				  .line()
				  .position('strKey*longKey')
				  .color('#9AD681')
				  .shape('dash');
				this.chart2.render();
			},
			
			drawChart3() {
				if (this.chart3) this.chart3.destroy();
				
				this.chart3 = new Chart({
					container: 'OrderChart',
					autoFit: true,
					height: 300,					  
				});
				
				this.chart3.data(this.data.orderData.orderDataList);
				this.chart3.scale({
				  // strKey: {
				  //   alias: '日期',
				  //   type: 'time',
				  // },
				  longKey: {
				    alias: '下单人数',
				    min: 0,
				    sync: true, // 将 pv 字段数值同 time 字段数值进行同步
				    nice: true,
				  },				 
				  intKey: {
				    alias: '订单数量',
				  },
				});
				this.chart3.axis('intKey', {
				  grid: null,
				  title: {},
				});
				this.chart3.axis('longKey', {
				  title: {},
				});
				this.chart3.legend({
				  custom: true,
				    items: [
				      {
				        name: '订单数量', // 图例项名称，对应数据中的颜色字段值				       
				        marker: {symbol: 'square', style: {fill: '#4FAAEB', r: 4}} // 自定义标记样式
				      },
				      {
				        name: '下单人数',				       
				        marker: {symbol: 'circle', style: {fill: '#9AD681', r: 4}}
				      }
				    ]
				});
				this.chart3.tooltip({
				  showCrosshairs: true,
				  shared: true,
				});
				
				this.chart3
				  .line()
				  .position('strKey*intKey')
				  .color('#4FAAEB');
				this.chart3
				  .line()
				  .position('strKey*longKey')
				  .color('#9AD681')
				  .shape('dash');
				this.chart3.render();
			},
			
			
		}
	}
</script>

<style lang="scss" scoped>
	.statistics-box {
		margin: 20px 0;

		.el-col {
			text-align: center;
			padding: 8px 0;

			.num {
				font-size: 16px;
				margin-bottom: 5px;
			}
		}
	}
</style>